import { api } from './api'

export type Me = { email: string; name: string | null; role: string; approvals_enabled: boolean }

export async function fetchMe(): Promise<Me | null> {
  try {
    return await api<Me>('/auth/me')
  } catch {
    return null
  }
}

export function loginRedirect(): void {
  window.location.href = '/api/auth/login'
}

export async function logout(): Promise<void> {
  await api('/auth/logout', { method: 'POST' })
  window.location.href = '/'
}
